export default __webpack_public_path__ + "static/media/financas-pessoais.512439f5.svg";